import React, { useRef, useState, useEffect, useCallback } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const formatCounter = (value) => {
	if (value == null) return "—";
	return Number(value).toLocaleString("de-DE", { maximumFractionDigits: 2 });
};

const MobileCalendarKpis = ({ items }) => {
	const scrollRef = useRef(null);
	const [showLeftHint, setShowLeftHint] = useState(false);
	const [showRightHint, setShowRightHint] = useState(false);

	const updateScrollHint = useCallback(() => {
		const el = scrollRef.current;
		if (!el) {
			setShowLeftHint(false);
			setShowRightHint(false);
			return;
		}
		const hasOverflow = el.scrollWidth > el.clientWidth + 1;
		const atStart = el.scrollLeft <= 2;
		const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
		setShowLeftHint(hasOverflow && !atStart);
		setShowRightHint(hasOverflow && !atEnd);
	}, []);

	useEffect(() => {
		updateScrollHint();
		const el = scrollRef.current;
		if (!el || typeof ResizeObserver === "undefined") return undefined;

		const observer = new ResizeObserver(updateScrollHint);
		observer.observe(el);
		return () => observer.disconnect();
	}, [items, updateScrollHint]);

	if (!items?.length) return null;

	return (
		<div className="mobile-calendar-view__kpis-wrap">
			<div
				ref={scrollRef}
				className="mobile-calendar-view__kpis"
				onScroll={updateScrollHint}
			>
				{items.map((c, i) => (
					<div className="mobile-calendar-kpi" key={`${c.label}-${i}`}>
						<span className="mobile-calendar-kpi__label">{c.label}</span>
						<span className="mobile-calendar-kpi__value">
							{formatCounter(c.value)}
						</span>
					</div>
				))}
			</div>
			{showLeftHint && (
				<div
					className="mobile-calendar-view__kpis-hint mobile-calendar-view__kpis-hint--left"
					aria-hidden="true"
				>
					<span className="mobile-calendar-view__kpis-hint-icon">
						<FiChevronLeft size={18} />
					</span>
				</div>
			)}
			{showRightHint && (
				<div
					className="mobile-calendar-view__kpis-hint mobile-calendar-view__kpis-hint--right"
					aria-hidden="true"
				>
					<span className="mobile-calendar-view__kpis-hint-icon">
						<FiChevronRight size={18} />
					</span>
				</div>
			)}
		</div>
	);
};

export default MobileCalendarKpis;
